import {useSelector} from 'react-redux';
import {IntlProvider} from 'react-intl';
import {selectTranslations} from '@components/appSlice';
import {selectRecipientLanguage} from './signerUiSlice';

export default function SignerUiIntlProvider({children}) {
    const locale = useSelector(selectRecipientLanguage);
    const translations = useSelector(selectTranslations);

    return (
        <IntlProvider locale={locale} messages={translations} key={locale}>
            {children}
        </IntlProvider>
    );
}
